import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import { scrollVertically } from '../../../../../../utils';
import SSBenefitsChart from '../../../../../../components/SSBenefitsChart';
import ACTIONS from '../../../../../../context/appActions';
import { useAppContext } from '../../../../../../context/appContext';
import './styles.scss';

const SSBenefits = () => {
  const { dispatch } = useAppContext();
  return (
    <Grid container className='ss-benefits-container' justifyContent='center' pt={10} sx={{ pl: { xs: 0, md: 9.8 }, pr: { xs: 0, md: 9.8 } }}>
      <Grid item xs={10} justifyContent='center'>
        <Typography variant='h2' className='chart-title'>
          Your Social Security benefits
          {' '}
          <span className='no-wrap'>at a glance</span>
        </Typography>
      </Grid>
      <Grid item xs={12} justifyContent='center'>
        <div className='ssbenefits-chart'>
          <SSBenefitsChart />
        </div>
        <Container>
          <Box sx={{ pl: { xs: 0, md: 20, lg: 30 }, pr: { xs: 0, md: 20, lg: 30 }, mb: { xs: 0, lg: 4 } }} textAlign='left'>
            <Typography variant='body1'>
              This hypothetical example assumes a 2.4% Cost-Of-Living Adjustment
              (COLA) and a life expectancy of age 90. Estimated Social Security
              payments (start age to age 90) are rounded to the nearest $5,000.
              Hypothetical examples are for illustrative and educational purposes
              only and not intended to predict future performance. The use of
              alternative assumptions could significantly change results.
            </Typography>
          </Box>
          <Box textAlign='center' sx={{ pr: { xs: 0 }, mb: { xs: 11 }, pt: { xs: 1.2 } }}>
            <Button
              color='inherit'
              onClick={() => {
                dispatch({ type: ACTIONS.UPDATE_STATE, data: { page: 'home' } });
                scrollVertically(2300, 250);
              }}
              className='ghost-btn'
            >
              Back to Calculator
            </Button>
          </Box>
        </Container>
      </Grid>
    </Grid>
  );
};

export default SSBenefits;
